import React from 'react';
import moment from "moment";
import styled from "styled-components";


import FlexRootWrapper from '../../components/general/flex-root';
import {ts_translate} from "../../common/clientTranslate";

const ChildrenWrapper = styled(FlexRootWrapper)`
    display: flex;
	flex-direction: row;
	flex: 1;
	border-bottom: 1px solid;
`

const Wrapper = styled(FlexRootWrapper)`
    display: flex;
	flex-direction: column;
	flex: 1;
`;


const Child = ({children}) => (

    <span>
        {children && <FlexRootWrapper>
            Besteht aus: <br/>
            <ChildrenWrapper key={'ChildrenWrapper-header'}>
                <Wrapper>
                    {ts_translate('Menge')}
                </Wrapper>
                <Wrapper flex={3}>
                    {ts_translate('ERP-Nr.', false)}
                </Wrapper>
                <Wrapper>
                    {ts_translate('Datum')}
                </Wrapper>
            </ChildrenWrapper>
            {children.map((child, index) => (
                <ChildrenWrapper key={`ChildrenWrapper-${index}`}>
                    <Wrapper>
                        {child.quantity}x
                    </Wrapper>
                    <Wrapper flex={3}>
                        {child.erpnumber}
                    </Wrapper>
                    <Wrapper>
                        ({moment(child.date).format('DD.MM')})
                    </Wrapper>
                </ChildrenWrapper>
            ))}

        </FlexRootWrapper>}
    </span>
);

export default Child;



// WEBPACK FOOTER //
// ./src/components/task/child.js